"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9060],{

/***/ 49060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ToolsBlock_ToolsBlock; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./theme/mixins/padding.ts
var padding = __webpack_require__(54986);
// EXTERNAL MODULE: ./components/Icons/Icon.tsx + 51 modules
var Icon = __webpack_require__(82218);
;// CONCATENATED MODULE: ./blocks/ToolsBlock/ToolsBlock.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: start;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 1.5rem;\n  font-weight: 400;\n  margin-bottom: 2.25rem !important;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: unset;\n    grid-template-columns: repeat(6, 1fr);\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 2rem;\n  width: 100%;\n\n  ",
        ";\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fit-content;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  path {\n    stroke: none;\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}





const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6ea876b7-0"
})(_templateObject(), ()=>(0,padding/* blockPadV */.zr)(), ()=>(0,padding/* blockPadH */.XA)());
const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6ea876b7-1"
})(_templateObject1(), ()=>(0,padding/* blockW */.g5)());
const Title = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-6ea876b7-2"
})(_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.fontStacks.sans;
});
const GridContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6ea876b7-3"
})(_templateObject4(), (param)=>{
    let { theme  } = param;
    return theme.mq.sm(_templateObject3());
});
const StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-6ea876b7-4"
})(_templateObject5());
const StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.Z).withConfig({
    componentId: "sc-6ea876b7-5"
})(_templateObject6());
const ToolsBlock = (param)=>{
    let { title , tools  } = param;
    const theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    if (!tools) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GridContainer, {
                    children: tools.map((item, idx)=>item && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            target: "_blank",
                            href: item.url || "",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                                name: item.toolIcon,
                                color: theme.themeColors.fg
                            }, "".concat(item.toolIcon, "-").concat(idx))
                        }))
                })
            ]
        })
    });
};
/* harmony default export */ var ToolsBlock_ToolsBlock = (ToolsBlock);

;// CONCATENATED MODULE: ./blocks/ToolsBlock/index.ts



/***/ })

}]);